import React from "react";
import { Modal } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";

export const DiscardWarning =
  ({ isChanged, onActionClick }) =>
  () => {
    if (isChanged) {
      Modal.confirm({
        title: "Do you want to discard changes?",
        icon: <ExclamationCircleOutlined />,
        okText: "Yes",
        cancelText: "No",
        onOk() {
          onActionClick(null, null)();
        },
      });
    } else {
      onActionClick(null, null)();
    }
  };
